<template>
  <div id="app">
    <!-- ナビゲーション -->
    <b-navbar class="shadow-sm align-items-center" variant="light" type="light">
      <b-navbar-nav>
        <b-button variant="link" @click="back">&lt; 戻る</b-button>
      </b-navbar-nav>
      <b-navbar-brand class="mx-4">{{this.title}}</b-navbar-brand>
      <b-navbar-nav class="ml-auto">
        <b-button variant="outline-primary" @click="onDeleteGame">ゲームを削除</b-button>
      </b-navbar-nav>
    </b-navbar>

    <!-- ゲームが見つからない場合 -->
    <div class="container" v-if="isNotFound">このゲームは削除されているか、権限がありません。</div>

    <!-- ゲーム -->
    <div class="container mt-4" v-if="!isNotFound">
      <!-- タイトル -->
      <h4>タイトルと説明文</h4>
      <!-- <div>{{this.description}}</div>-->
      <b-form @submit.prevent="updateGameData">
        <b-form-group label="タイトル" label-for="titleInput">
          <b-form-input
            type="text"
            id="titleInput"
            v-model="gameForm.title"
            placeholder="title"
            required
          ></b-form-input>
        </b-form-group>
        <b-form-group label="説明文" label-for="desInput">
          <b-form-textarea
            id="desInput"
            v-model="gameForm.description"
            placeholder="ゲーム説明文..."
            rows="4"
            max-rows="8"
          ></b-form-textarea>
        </b-form-group>
        <div class="d-flex flex-row-reverse">
          <b-button type="submit" variant="primary" class="mr-1">更新</b-button>
        </div>
      </b-form>

      <!-- 全体画像データ -->
      <div class="mt-4">
        <h4>画像</h4>
        <div class="d-flex">
          <amplify-s3-album :path="gameImageFolderPath + 'zentai/'" />

          <amplify-photo-picker :photoPickerConfig="getPhotoPickerConfig('zentai/')" />
          <!-- <b-card class="mb-2" title="画像を消去">
          <b-form class="col" @submit.prevent="onDeleteMainImage">
             <b-form-group label="画像名" label-for="upInput">
              <b-form-input
                type="text"
                id="upInput"
                v-model="createCardForm.tag"
                placeholder=""
              ></b-form-input>
            </b-form-group>

            <div class="d-flex flex-row-reverse">
              <b-button type="submit" variant="primary" class="mr-1">消去</b-button>
            </div>
          </b-form>
          </b-card>-->
        </div>
      </div>
      <div class="mt-4">
        <h4>キャラクター</h4>
        <div class="d-flex">
          <b-card v-for="character in characterList" :key="character.id">
            <h5>{{ character.name }}</h5>
            <!-- <div>全体に見える画像</div>
          <amplify-s3-album
            :path="gameImageFolderPath + character.name + '/open'"
          />

          <amplify-photo-picker
            :photoPickerConfig="getPhotoPickerConfig(character.name + '/open')"
          />
          <div>プレイヤーのみ見える画像</div>
          <amplify-s3-album
            :path="gameImageFolderPath + character.name + '/close'"
          />

          <amplify-photo-picker
            :photoPickerConfig="getPhotoPickerConfig(character.name + '/close')"
            />-->
          </b-card>
          <!-- card form -->
          <b-card class="mb-2" title="キャラクターを作成">
            <b-form class="col" @submit.prevent="onCreateCharacter">
              <b-form-group label="名前" label-for="charaNameInput">
                <b-form-input
                  type="text"
                  id="charaNameInput"
                  v-model="createCharacterForm.name"
                  placeholder="キャラクター名"
                ></b-form-input>
              </b-form-group>
              <div class="d-flex flex-row-reverse">
                <b-button type="submit" variant="primary" class="mr-1">作成</b-button>
              </div>
            </b-form>
          </b-card>
        </div>
      </div>

      <!-- タグフィールド -->
      <div class="mt-4">
        <h4>カードのタグ一覧</h4>
        <b-form>
          <b-form-group label label-for="tagInput">
            <b-form-tags
              id="tagInput"
              v-model="fieldTagList"
              separator=" ,;"
              placeholder="入力後スペースかコロンで決定する  e.g.. 犯行現場"
              @input="changeTagSelect"
            ></b-form-tags>
          </b-form-group>
        </b-form>
      </div>
      <!-- 使うカード一覧 -->
      <div class="mt-4">
        <h4>カード</h4>
        <div class="d-flex">
          <div class="border rounded p-1" v-for="card in cardList" v-bind:key="card.id">
            <div>タグ : {{ card.tag }}</div>
            <div>表 : {{ card.faceUpString }}</div>
            <div>裏 : {{ card.faceDownString }}</div>
            <div>
              <b-button variant="primary" @click="onRemoveCard(card.id)">カードを削除</b-button>
            </div>
          </div>
          <div>
            <!-- card form -->
            <b-card class="mb-2" title="カードを作成">
              <b-form class="col" @submit.prevent="onCreateCardForm">
                <b-form-group label="タグ" label-for="tagSelect">
                  <b-form-select
                    id="tagSelect"
                    v-model="createCardForm.tag"
                    :options="getSelectTagOption"
                    @input="onSelectCardTag"
                  ></b-form-select>
                </b-form-group>
                <b-form-group label="表面" label-for="upInput">
                  <b-form-input
                    type="text"
                    id="upInput"
                    v-model="createCardForm.faceUpString"
                    placeholder="表文字"
                  ></b-form-input>
                </b-form-group>
                <b-form-group label="裏面" label-for="downInput">
                  <b-form-textarea
                    id="downInput"
                    v-model="createCardForm.faceDownString"
                    placeholder="裏文字"
                    rows="3"
                  ></b-form-textarea>
                </b-form-group>

                <div class="d-flex flex-row-reverse">
                  <b-button type="submit" variant="primary" class="mr-1">作成</b-button>
                </div>
              </b-form>
            </b-card>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getGame } from "../graphql/queries";
import { updateGame, deleteGame } from "../graphql/mutations";
import { onUpdateGame } from "../graphql/subscriptions";
import { graphqlQuery } from "../util/queryUtil";
import UserStore from "@/store/index.js";

export default {
  name: "App",
  data() {
    return {
      owner: "",
      isNotFound: false,

      gameId: "",
      title: "",
      description: "",
      errorMessage: "",

      cardList: [],
      characterList: [],

      nextToken: "",

      gameImageFolderPath: `${this.$route.params.gameName}/`,
      photoPickerConfig: {
        header: "画像をアップロードする",
        accept: "image/*",
        path: `${this.$route.params.gameName}/`
      },

      createCardForm: { tag: "", faceUpString: "", faceDownString: "" },
      createCharacterForm: { name: "" },

      gameForm: { title: "", description: "" },

      fieldTagList: []
    };
  },
  methods: {
    back() {
      this.$router.go(-1);
    },
    getUniqueStr(myStrong) {
      var strong = 1000;
      if (myStrong) strong = myStrong;
      return (
        new Date().getTime().toString(16) +
        Math.floor(strong * Math.random()).toString(16)
      );
    },

    onSelectCardTag(value) {
      // console.log(value);
      this.createCardForm.faceUpString = value;
    },

    //カード追加フォームをクリック時
    onCreateCardForm() {
      let card = {
        id: this.getUniqueStr(), // ランダム文字列
        tag: this.createCardForm.tag,
        faceUpString: this.createCardForm.faceUpString,
        faceDownString: this.createCardForm.faceDownString
      };
      this.cardList.push(card);
      this.updateGameData();
    },

    onCreateCharacter() {
      let chara = {
        id: this.getUniqueStr(),
        name: this.createCharacterForm.name
      };
      this.characterList.push(chara);
      this.updateGameData();
    },

    // ゲームデータを移し替える
    _setUpGameData(gameData) {
      // なかったらnot found表示
      if (gameData == null) {
        this.isNotFound = true;

        return;
      }

      // データ移し替え
      this.owner = gameData.owner;
      this.gameId = gameData.id;
      this.title = gameData.title;
      this.description = gameData.description;
      this.cardList = gameData.cards;
      this.characterList = gameData.characters;
      this.fieldTagList = gameData.fieldTags;
      this.gameForm.title = this.title;
      this.gameForm.description = this.description;
    },

    // ゲームデータ全体を更新
    updateGameData() {
      let value = {
        input: {
          id: this.gameId,
          title: this.gameForm.title,
          description: this.gameForm.description,
          cards: this.cardList,
          characters: this.characterList,
          fieldTags: this.fieldTagList
        }
      };
      //   console.log(value);
      graphqlQuery(this, updateGame, value, result => {
        console.log("update game");
        console.log(result);
        this._setUpGameData(result.data.updateGame);
      });
    },

    // ゲームデータのサブスクライブを設定
    gameSubscribe() {
      this.$Amplify.API.graphql({
        query: onUpdateGame,
        variables: {
          owner: UserStore.state.user.username
        }
      }).subscribe({
        error: error => {
          console.error("subsc error", error);
        },
        next: diff => {
          console.log("subsc diff", diff);
          if (this.gameId === diff.value.data.onUpdateGame.id) {
            this._setUpGameData(diff.value.data.onUpdateGame);
          }
        }
      });
    },

    changeTagSelect() {
      this.updateGameData();
    },

    onRemoveCard(cardId) {
      this.cardList = this.cardList.filter(card => card.id !== cardId);
      this.updateGameData();
    },

    onDeleteGame() {
      graphqlQuery(this, deleteGame, { input: { id: this.gameId } }, () => {
        this.isNotFound = true;
      });
    }
  },

  computed: {
    getPhotoPickerConfig() {
      return str => {
        // console.log(this.gameImageFolderPath + str);
        return {
          header: "画像をアップロードする",
          accept: "image/*",
          path: this.gameImageFolderPath + str
        };
      };
    },

    getSelectTagOption() {
      return this.fieldTagList.map(tag => {
        return { value: tag, text: tag };
      });
    }
  },

  mounted() {
    this.gameId = this.$route.params.gameName;
    // console.log(this.gameId);
    // Gameデータ取る
    this.$Amplify.API.graphql({
      query: getGame,
      variables: {
        id: this.gameId
      }
    })
      .then(result => {
        this._setUpGameData(result.data.getGame);
      })
      .catch(e => {
        if (e.errors != null) {
          this.isNotFound = true;
        } else {
          console.error(e);
        }
      });

    this.gameSubscribe();
  }
};
</script>
